export default {
  // list
  'crm_customer_account.column.customerId': 'customerId',
  'crm_customer_account.column.accountName': 'accountName',
  'crm_customer_account.column.bankName': 'bankName',
  'crm_customer_account.column.bankAccount': 'bankAccount',
  'crm_customer_account.column.bankBranch': 'bankBranch',
  'crm_customer_account.column.accountHolder': 'accountHolder',
  'crm_customer_account.column.primaryFlag': 'primaryFlag',
  'crm_customer_account.column.enableFlag': 'enableFlag',
  'crm_customer_account.column.createBy': 'createBy',
  'crm_customer_account.column.updateBy': 'updateBy',
  'crm_customer_account.column.createTime': 'createTime',
  'crm_customer_account.column.updateTime': 'updateTime',
  'crm_customer_account.column.dataSource': 'dataSource',
  'crm_customer_account.column.remark': 'remark',
  'crm_customer_account.column.status': 'status',
  // edit
  'crm_customer_account.edit.title': 'Edit CrmCustomerAccount',
  'crm_customer_account.add.title': 'Add CrmCustomerAccount',
  'crm_customer_account.edit.success': 'Edit Successful',
  'crm_customer_account.add.success': 'Add Successful',
  'crm_customer_account.form.accountName.required': 'accountName cannot be null',
  'crm_customer_account.form.bankName.required': 'bankName cannot be null',
  'crm_customer_account.form.bankAccount.required': 'bankAccount cannot be null',
  'crm_customer_account.form.bankBranch.required': 'bankBranch cannot be null',
  'crm_customer_account.form.primaryFlag.required': 'primaryFlag cannot be null',
  'crm_customer_account.form.enableFlag.required': 'enableFlag cannot be null',
  'crm_customer_account.form.accountName': 'accountName',
  'crm_customer_account.form.accountName.placeholder': 'Enter accountName',
  'crm_customer_account.form.bankName': 'bankName',
  'crm_customer_account.form.bankName.placeholder': 'Enter bankName',
  'crm_customer_account.form.bankAccount': 'bankAccount',
  'crm_customer_account.form.bankAccount.placeholder': 'Enter bankAccount',
  'crm_customer_account.form.bankBranch': 'bankBranch',
  'crm_customer_account.form.bankBranch.placeholder': 'Enter bankBranch',
  'crm_customer_account.form.accountHolder': 'accountHolder',
  'crm_customer_account.form.accountHolder.placeholder': 'Enter accountHolder',
  'crm_customer_account.form.primaryFlag': 'primaryFlag',
  'crm_customer_account.form.primaryFlag.placeholder': 'Enter primaryFlag',
  'crm_customer_account.form.enableFlag': 'enableFlag',
  'crm_customer_account.form.enableFlag.placeholder': 'Enter enableFlag',
  'crm_customer_account.form.remark': 'remark',
  'crm_customer_account.form.remark.placeholder': 'Enter remark',
}
